// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import config from "./config";  // ✅ `config.js` を読み込む

// Firebase の設定を config.js から取得（src/config.jsで設定できる）
const firebaseConfig = config.firebase;

// Firebase を初期化
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db, analytics };
